/** Saltus IM dock layout — Home is the leading special button (see OsDock). */
export const SALTUS_COMPANY_ID = "saltus";

/** Apps pinned to the dock for Saltus (excludes ``home`` — special button). */
export const SALTUS_DOCK_APP_IDS = [
  "dashboard",
  "screener",
  "playground",
  "reports",
  "rebalancing",
  "ops",
] as const;

/** Apps a Saltus user may pin, in dock order — adviser apps lead the IM defaults. */
export const SALTUS_PINNABLE_APP_IDS = ["meetings", "artifacts", ...SALTUS_DOCK_APP_IDS] as const;

/** Permissioned but not shown in dock or Apps grid. */
export const SALTUS_HIDDEN_APP_IDS = new Set(["mission-control", "missions"]);

export function isSaltusCompany(companyId?: string | null): boolean {
  return (companyId ?? "").toLowerCase() === SALTUS_COMPANY_ID;
}

export function filterSaltusHiddenAppIds(appIds: string[]): string[] {
  return appIds.filter((id) => !SALTUS_HIDDEN_APP_IDS.has(id));
}

export function orderSaltusDockAppIds(appIds: string[]): string[] {
  const set = new Set(appIds);
  return SALTUS_PINNABLE_APP_IDS.filter((id) => set.has(id));
}
